export function initializeFrontendBlocks(
  blockName: string,
  initializeBlock: ((element: HTMLElement) => void) | ((HTMLDivElement) => void),
) {
  // Initialize each block on page load (front end).
  window.addEventListener("DOMContentLoaded", function () {
    const blockElements = document.querySelectorAll<HTMLElement>(
      ".wp-block-" + blockName.replace("/", "-"),
    );

    blockElements.forEach(function (blockElement) {
      initializeBlock(blockElement);
    });
  });
}

export function initializeEditorBlocks(
  blockName: string,
  initializeBlock: ((element: HTMLElement) => void) | ((HTMLDivElement) => void),
): void {
  // Initialize dynamic block preview (editor).
  if (!window.acf) {
    return;
  }

  window.acf.addAction(
    `render_block_preview/type=${blockName}`,
    function ($block, r) {
      const block: HTMLElement | null = $block[0];

      if (!block) {
        return;
      }

      const className = "wp-block-" + blockName.replace("/", "-");
      const selector = `.${className}`;

      const blockElement = block.classList.contains(className)
        ? block
        : block.querySelector<HTMLElement>(selector);

      if (!blockElement) {
        return;
      }

      initializeBlock(blockElement);
    },
  );
}
